import AuditPage from 'app/pages/Audit/AuditPage';
import GuideNotFoundPage from 'app/pages/GuideNotFound/GuideNotFoundPage';
import HomePage from 'app/pages/Home/HomePage';
import IdPGuideStepPage from 'app/pages/IdPGuideStep/IdPGuideStepPage';
import JitConfigPage from 'app/pages/JitConfigPage/JitConfigPage';
import SelectIdPPage from 'app/pages/SelectIdPPage/SelectIdPPage';
import SelectSCIMIdPPage from 'app/pages/SelectSCIMIdPPage/SelectSCIMIdPPage';
import SelectXAAIdPPage from 'app/pages/SelectXAAIdPPage/SelectXAAIdPPage';
import TestingPage from 'app/pages/TestingPage/TestingPage';
import { ROUTES } from 'constants/routes';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Navigate, Route, Routes } from 'react-router-dom';
import { toRelativeRoute } from 'utils/routeUtils';
import RouterPageLayout from './RouterPageLayout';

const AuthenticatedRoutes = () => (
	<Routes>
		<Route path="*" element={<RouterPageLayout />}>
			<Route path={toRelativeRoute(ROUTES.home)} element={<HomePage />} />
			<Route
				path={toRelativeRoute(ROUTES.guideNotFound)}
				element={<GuideNotFoundPage />}
			/>
			<Route
				path={toRelativeRoute(ROUTES.selectIdP)}
				element={<SelectIdPPage />}
			/>
			<Route path={toRelativeRoute(ROUTES.jit)} element={<JitConfigPage />} />
			<Route
				path={toRelativeRoute(ROUTES.selectScim)}
				element={<SelectSCIMIdPPage />}
			/>
			<Route
				path={toRelativeRoute(ROUTES.selectXaa)}
				element={<SelectXAAIdPPage />}
			/>
			<Route
				path={toRelativeRoute(ROUTES.guideStep)}
				element={<IdPGuideStepPage />}
			/>
			<Route path={toRelativeRoute(ROUTES.testing)} element={<TestingPage />} />
			<Route path={toRelativeRoute(ROUTES.audit)} element={<AuditPage />} />
			<Route
				path="*"
				element={<Navigate to={toRelativeRoute(ROUTES.home)} replace />}
			/>
		</Route>
	</Routes>
);

export default AuthenticatedRoutes;
